import { Http } from './http';
import { Product, ProductBrand, ProductOriginType } from '@types';

class ProductHttp extends Http {

  async getListWithoutLimit(): Promise<Product[]> {
    const res = await this.get<Product[]>('product/all');

    return res.data;
  }

  async getAllList(params?: GetAllProductQuery): Promise<Product[]> {
    const res = await this.get<Product[]>('product', { params });

    return res.data;
  }

  async getBrandsList(): Promise<ProductBrand[]> {
    const params = { _end: 999999, _order: 'DESC', _sort: 'id', _start: 0 };
    const res = await this.get<ProductBrand[]>('product-brand', { params });

    return res.data;
  }

  async getCategoryList(): Promise<ProductBrand[]> {
    const params = { _end: 999999, _order: 'DESC', _sort: 'id', _start: 0 };
    const res = await this.get<ProductBrand[]>('product/category-list', { params });

    return res.data;
  }

  async getSubcategoryList(): Promise<ProductBrand[]> {
    const params = { _end: 999999, _order: 'DESC', _sort: 'id', _start: 0 };
    const res = await this.get<ProductBrand[]>('product/subcategory-list', { params });

    return res.data;
  }

  async update(productId: number, values: {[key: string]: any}) {
    await this.put(`/${productId}`, values);
  }

  async create(params: CreateProductParams): Promise<Product> {
    const res = await this.post<Product>('product/external', params);

    return res.data;
  }

  async updateBulk(params: UpdateBulkParams): Promise<number> {
    const { data } = await this.put<number>('product/update-bulk', params);

    return data;
  }

  async importCsvFile(file: FormData): Promise<any> {
    const res = await this.post<any>(
      'product/import-csv-file',
      file,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );

    return res.data;
  }
}

export const productHttp = new ProductHttp();

export interface CreateProductParams {
  name: string;
  brandId: number;
  categoryId: number;
  subcategoryId: number;
  externalShop: string;
  description?: string | null;
  pdfLink?: string | null;
  image?: string;
  origin?: ProductOriginType | null;
}

interface UpdateBulkParams {
  selectedIds: number[];
  prop: string;
  value: string | number | null;
}

interface GetAllProductQuery {
  divisionId?: number | number[];
  distributor?: string | string[];
  price?: number | string;
  category?: string | string[];
  subcategory?: string | string[];
  dosePerHa?: string | string[];
  pack?: string | string[];
  application?: string | string[];
  formIds?: number | number[];
  crops?: number | number[];
  allCrops?: boolean;
  s?: string;
  isExternal?: boolean;
  isEnabled?: boolean;
  externalShop?: boolean;
  id?: number[];
  q?: string;
  _start?: number;
  _end?: number;
  _sort?: string;
  _order?: 'ASC' | 'DESC';
  marketplaceDealerId?: number;
}
